import { baseApi, customErrorHandler, TAGS } from '@/shared/api'
import type { ThreadsResponse, Thread } from '../model/types'

const threadsApi = baseApi.injectEndpoints({
	endpoints: (build) => ({
		getThreads: build.query<ThreadsResponse, void>({
			query: () => `/threads`,
			transformErrorResponse: customErrorHandler,
			keepUnusedDataFor: 0,
			providesTags: [TAGS.THREADS]
		}),
        createThread: build.mutation<Thread, void>({
            query: () => ({
                url: `/threads`,
                method: 'POST',
            }),
            transformErrorResponse: customErrorHandler,
            invalidatesTags: [TAGS.THREADS]
        }),
        deleteThread: build.mutation<void, { threadId: string }>({
            query: ({ threadId }) => ({
                url: `/threads/${threadId}`,
                method: 'DELETE',
            }),
            transformErrorResponse: customErrorHandler,
            invalidatesTags: [TAGS.THREADS]
        })
	})
})

export const { useGetThreadsQuery, useCreateThreadMutation, useDeleteThreadMutation } = threadsApi
